import { GettextInterface } from '@indeed/indeed-gettext';
import { createContext, useContext } from 'react';

/**
 * I18n Context - provides gettext instance to components
 * Default value is null - useI18n will throw if used outside provider
 *
 * Note: For locale, use `useInitialState()` from InitialStateContext
 */
export const I18nContext = createContext<GettextInterface | null>(null);

/**
 * Hook to access gettext instance from context
 *
 * @throws Error if used outside of I18nContext.Provider
 * @example
 * ```tsx
 * const gt = useI18n();
 * gt.gettext('Hello');
 *
 * // For locale, use InitialStateContext:
 * const { locale } = useInitialState();
 * ```
 */
const useI18n = (): GettextInterface => {
    const context = useContext(I18nContext);
    if (context === null) {
        throw new Error('useI18n must be used within I18nContext.Provider');
    }
    return context;
};

export default useI18n;
